import { render } from "./userView.vue?vue&type=template&id=4998a01f&scoped=true"
import script from "./userView.vue?vue&type=script&lang=js"
export * from "./userView.vue?vue&type=script&lang=js"

import "./userView.vue?vue&type=style&index=0&id=4998a01f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4998a01f"]])

export default __exports__